import { Button, Grid } from "@mui/material";
import { Vocabulary } from "../Utils/Vocabulary";
import { getData } from "../Services/getData";
import { urlEnum } from "../Utils/UrlEnum";
import { toast } from "react-toastify";

async function handleAnaf() {
  try {
    const user = (await getData(`${urlEnum.customers}/users/mainUser`)).data;
    if (user) {
      if (user.cif !== 0) {
        await getData(`${urlEnum.anaf}/efactura/getToken`);
        toast.info("Implementation successful");
      } else {
        toast.error("CIF is not set");
      }
    } else {
      toast.error("Main user data missing");
    }
  } catch (error) {
    toast.error(`${error}`);
  }
}
export default function Anaf() {
  return (
    <Grid container spacing={2} style={{ marginTop: 50 }}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Button
          onClick={() => {
            handleAnaf();
          }}
          type="submit"
          variant="contained"
        >
          {Vocabulary.implementAnaf}
        </Button>
      </Grid>
    </Grid>
  );
}
